export function parseLocalDate(dateStr: string): Date | null {
  const parts = dateStr.trim().split('-').map(Number);
  if (parts.length !== 3) return null;
  const [y, m, d] = parts;
  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) return null;
  const date = new Date(y, m - 1, d, 0, 0, 0, 0);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function getRangeFromTimeRange(
  value: string,
  customFrom?: string,
  customTo?: string
): { from: string; to: string } {
  if (value === 'custom' && customFrom && customTo) {
    const from = parseLocalDate(customFrom);
    const to = parseLocalDate(customTo);
    if (from && to && from <= to) {
      const toEnd = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59, 999);
      return { from: from.toISOString(), to: toEnd.toISOString() };
    }
  }
  const to = new Date();
  let from: Date;
  const now = to.getTime();
  if (value === 'today') {
    from = new Date(to);
    from.setHours(0, 0, 0, 0);
  } else if (value === 'week') {
    from = new Date(now - 7 * 24 * 60 * 60 * 1000);
  } else if (value === 'month') {
    from = new Date(now - 30 * 24 * 60 * 60 * 1000);
  } else if (value === 'quarter') {
    from = new Date(now - 90 * 24 * 60 * 60 * 1000);
  } else {
    from = new Date(now - 30 * 24 * 60 * 60 * 1000);
  }
  return { from: from.toISOString(), to: to.toISOString() };
}

export function formatNumber(num: number): string {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return new Intl.NumberFormat().format(num);
}

export function calculateTrend(
  current: number,
  previous: number
): { value: number; positive: boolean } {
  if (previous === 0) return { value: current > 0 ? 100 : 0, positive: current > 0 };
  const change = ((current - previous) / previous) * 100;
  return { value: Math.abs(change), positive: change > 0 };
}
